module.exports = __webpack_public_path__ + "static/EWY_Bilaal-5892c34a1ad9d50de4f5b2429293e0d2.mp4";